// extracted by mini-css-extract-plugin
export default {"missions":"mission_missions__+Zz62","mission":"mission_mission__isDYW","right_border":"mission_right_border__pMk1t"};